import React from 'react';
import logo from './logo.svg';
import './App.css';
import FileUpload from './FileUpload'
function App() {
  return (
    <div className="App">
      <FileUpload/>
    </div>
  );
}

export default App;
